import { apiClient } from "../../api/apiClient.js";

// Thin fetch wrappers over the real P140A Backoffice Agent Buddy Guarantee
// API (GET/POST/PUT/POST .../revoke under api/backoffice/agent/buddy-
// guarantees). Every query param is optional - visibility scoping
// (Agent/PLC/SuperAgent/SuperAdmin) always happens on the backend from the
// caller's own session, never from a value this file sends. No notification
// send / emergency dispatch export exists here - this file only ever calls
// the five real CRUD routes.

const LIST_PATH = "/backoffice/agent/buddy-guarantees";

// Exactly the param names the P140A contract whitelists
// (BackofficeAgentBuddyGuaranteesController.List) - anything else passed to
// listBuddyGuarantees is silently dropped rather than forwarded, so a
// typo'd key can never accidentally reach the backend as an unfiltered
// pass-through.
const LIST_PARAM_KEYS = [
  "buddyStatus",
  "workerApplicationId",
  "workerProfileId",
  "agentId",
  "superAgentOrganizationId",
  "plcOrganizationId",
  "search",
  "page",
  "pageSize",
];

/** Builds a query string with every empty/null/undefined value omitted entirely (never sent as `key=`). */
function buildListQuery(params = {}) {
  const searchParams = new URLSearchParams();
  for (const key of LIST_PARAM_KEYS) {
    const value = params[key];
    if (value === null || value === undefined || value === "") {
      continue;
    }
    searchParams.set(key, String(value));
  }
  const query = searchParams.toString();
  return query ? `?${query}` : "";
}

export function listBuddyGuarantees(params = {}) {
  return apiClient.get(`${LIST_PATH}${buildListQuery(params)}`);
}

export function getBuddyGuarantee(buddyGuaranteeId) {
  if (!buddyGuaranteeId) {
    throw new Error("getBuddyGuarantee requires a buddyGuaranteeId");
  }
  return apiClient.get(`${LIST_PATH}/${encodeURIComponent(buddyGuaranteeId)}`);
}

export function createBuddyGuarantee(payload) {
  return apiClient.post(LIST_PATH, payload);
}

export function updateBuddyGuarantee(buddyGuaranteeId, payload) {
  if (!buddyGuaranteeId) {
    throw new Error("updateBuddyGuarantee requires a buddyGuaranteeId");
  }
  return apiClient.put(`${LIST_PATH}/${encodeURIComponent(buddyGuaranteeId)}`, payload);
}

export function revokeBuddyGuarantee(buddyGuaranteeId) {
  if (!buddyGuaranteeId) {
    throw new Error("revokeBuddyGuarantee requires a buddyGuaranteeId");
  }
  return apiClient.post(`${LIST_PATH}/${encodeURIComponent(buddyGuaranteeId)}/revoke`, {});
}
